import { Permissions } from '../../../Enums/permission.enum';
import { User } from '../../../Models/avyna/user.model';

export function isModeratorCreateBlocked(
  user: User | null | undefined,
  settingKey: 'moderator_can_create_applications' | 'moderator_can_create_groups',
  bypassPermission: Permissions,
): boolean {
  if (!user || user.is_root || user.hasPermission(bypassPermission)) {
    return false;
  }

  return user.general_settings?.[settingKey] === false;
}

export function stripTrailingAddSegment(url: string): string {
  const path = url.split('?')[0];
  return path.replace(/\/add$/, '') || '/';
}
